export default __webpack_public_path__ + "static/d1b291a5963c27c542c6752220fa5e88.ttf";